var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner",style:({
		marginTop: _vm.data.marginTop + 'px',
		paddingTop: _vm.data.paddingTop + 'px',
		paddingLeft: _vm.data.paddingLeft + '%',
		paddingRight: _vm.data.paddingRight + '%',
	})},[(_vm.data.data && _vm.data.data.length > 0)?_c('el-carousel',{attrs:{"height":"176px"}},_vm._l((_vm.data.data),function(item,index){return _c('el-carousel-item',{key:index},[_c('a',{attrs:{"href":item.link}},[_c('img',{attrs:{"src":item.url}})])])}),1):_c('div',{staticClass:"image-null"},[_c('span',{staticClass:"el-icon-picture"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }